<template>
    <div class="c-panorama" :data-binary-src="this.src">
        <div class="c-panorama__view js-viewer"
        @click="onPanoramaClick"
        @touchstart="onTouchStart"
        @mousedown="onTouchStart"
        @touchmove="onTouchMove"
        @mousemove="onTouchMove"
        @touchend="onTouchEnd"
        @mouseup="onTouchEnd">
        </div>
        <div
        v-if="isOrientationSupported && $xp.settings.mergedSettings.isPanoramaDeviceOrientationEnabled"
        :class="{
          'c-panorama__orientation-btn': true,
          'c-panorama__orientation-btn--hidden': this.$xp.navigation.isNavHidden || !this.$xp.navigation.isChildPagesMenuHidden,
          'c-panorama__orientation-btn--active': isOrientationActive
        }"
        @click="toggleOrientation">
          <span class="xp xp--large xp-auto_rotate"></span>
        </div>
        <img v-if="showHint"
          :class="{ 'c-panorama__swipe-hint': true, 'animated': isInitialized, 'fadeOut': isInitialized }"
          src="data:image/svg+xml;base64,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" tabindex="-1" aria-hidden="true"/>
        <div class="sr-nav">
            <a
                    class="link sr-only sr-only-focusable"
                    tabindex="0"
                    href="#"
                    role="link"
                    @click.prevent="hotspotClicked(hotspot)"
                    v-for="(hotspot, index) in hotspots"
                    v-bind:key="index">
                <span  v-if="hotspot.alt.length > 0" >{{ hotspot.alt }}</span>
                <span v-else >HotSpot {{ index }}</span>
            </a>
        </div>
    </div>

</template>

<script>
import throttle from '../util/throttle'
import base64ToBlob from '../util/base64ToBlob'
import 'pannellum/src/js/pannellum'
import 'pannellum/src/js/libpannellum'
import hotspotsMixin from '../mixins/hotspots'
/**
 * Panorama components uses [pannellum](https://github.com/mpetroff/pannellum) which is not an optimal option but the best available one.
 * pannellum does not export es modules but adds its functionality under window object (that's why it is not optimal).
 * Please pay attention when upgrading pannellum, the css should be updated in this component.
 */
export default {
  name: 'Panorama',
  mixins: [hotspotsMixin],
  props: {
    src: {
      type: String,
      required: true
    },
    startLookAtX: Number,
    width: Number,
    height: Number,
    type: {
      type: String,
      default: 'cylinder'
    },
    thumb: {
      type: String
    }
  },
  data () {
    return {
      ready: false,
      onMouseDownPitch: 0,
      onMouseDownYaw: 0,
      onMouseDownTime: 0,
      isInitialized: false,
      showHint: true,
      isOrientationSupported: false,
      isOrientationActive: false
    }
  },
  created () {
    this.savePanoramaPosition = throttle(this.savePanoramaPosition, 200)
    this.screenUnwatcher = this.$watch(() => [
      // this.$xp.screen.orientation,
      this.$xp.screen.width,
      this.$xp.screen.height
    ].join(), async val => {
      console.log('screen watcher ' + val)
      await this.$nextTick()
      setTimeout(() => {
        console.log('---reinit')
        this.viewer.destroy()
        this.init()
        this.isOrientationActive && this.viewer.startOrientation()
      }, 0)
    })
  },
  mounted () {
    this.isUserInteracting = false
    this.pageId = this.$route.params.id
    this.init()
  },
  methods: {
    async init () {
      this.container = this.$el.querySelector('.js-viewer')
      this.hfov = this.type === 'cylinder'
        ? Math.min(120, this.container.clientWidth / (this.width * this.container.clientHeight / this.height) * 360)
        : 100
      this.vaov = 180
      if (this.type === 'cylinder') {
        this.vaov = 2 * Math.atan(Math.tan(this.hfov / 180 * Math.PI * 0.5) / (this.container.clientWidth / this.container.clientHeight)) / Math.PI * 180
      }
      let yaw = -180 // To be compatible with previous implementations
      let pitch = 0
      const historyYaw = this.$xp.history.historyParams.yaw
      const historyPitch = this.$xp.history.historyParams.pitch
      if (this.startLookAtX) {
        yaw = (this.startLookAtX / this.width) * 360 - 180
      }
      if (historyYaw) {
        yaw = historyYaw
      }
      if (historyPitch) {
        pitch = historyPitch
      }
      this.viewer = window.pannellum.viewer(this.container, {
        default: {
          type: 'equirectangular',
          showControls: false,
          keyboardZoom: false,
          mouseZoom: false,
          showFullscreenCtrl: false,
          hfov: this.hfov,
          yaw: yaw,
          pitch: pitch,
          vaov: this.vaov,
          autoLoad: true,
          friction: 0.5,
          orientationOnByDefault: false,
          hotSpots: this.htmlIconHotspots.map(item => ({
            // (yPercentange - 0.5) * -180
            pitch: (item.centerYPercent - 0.5) * -this.vaov,
            // xPercentage * 360
            yaw: (item.centerXPercent - 0.5) * 360,
            type: 'info',
            text: item.alt,
            href: item.href,
            cssClass: `xp xp--large c-panorama__hotspot-icon c-panorama__hotspot-icon--${item.icon}`,
            createTooltipFunc: () => { console.log('empty create tooltip function') }
          })),
          preview: this.thumb || 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=',
          firstScene: 'preview'
        },
        scenes: {
          preview: {
            panorama: this.thumb ? base64ToBlob(this.thumb) : base64ToBlob('iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=')// this.src,
          }
        }
      })
      this.viewer.on('load', this.onViewerLoad)
    },
    onViewerLoad () {
      this.viewer.off('load', this.onViewerLoad)
      this.ready = true
      this.isOrientationSupported = this.viewer.isOrientationSupported()
      this.isOrientationActive = this.viewer.isOrientationActive()
      this.setOrientationFromHistory()
      const renderContainer = this.$el.querySelector('div.pnlm-render-container')
      const panoramaUi = this.$el.querySelector('div.pnlm-ui')
      renderContainer.parentNode.insertBefore(renderContainer, panoramaUi)
      this.viewer.on('mouseup', this.savePanoramaPosition)
      this.viewer.on('touchend', this.savePanoramaPosition)
      this.viewer.on('animatefinished', this.savePanoramaPosition)
      this.setPanoramaBounds()
      this.isInitialized = true
      this.$xp.http.getFileUrl(this.src).then(base64 => {
        this.viewer.addScene('full', {
          panorama: base64
        })
        this.viewer.loadScene('full')
        this.viewer.on('load', () => {
          this.setPanoramaBounds()
          this.$el.querySelectorAll('.c-panorama__hotspot-icon').forEach(hotspotElem => {
            hotspotElem.setAttribute('aria-hidden', true)
          })
        })
      })
    },
    setPanoramaBounds () {
      if (this.type === 'cylinder') {
        this.lockPitch()
        setTimeout(() => {
          this.viewer.setHfovBounds([this.hfov, this.hfov])
          this.viewer.setHfov(this.hfov, false)
        }, 0)
      } else {
        this.viewer.setHfovBounds([this.viewer.getHfov(), this.viewer.getHfov()])
      }
    },
    savePanoramaPosition () {
      this.$xp.history.setHistoryParam(this.pageId, 'yaw', this.viewer.getYaw())
      this.$xp.history.setHistoryParam(this.pageId, 'pitch', this.viewer.getPitch())
    },
    lockPitch () {
      const renderer = this.viewer.getRenderer()
      if (renderer) {
        const canvas = renderer.getCanvas()
        if (canvas) {
          const vfov = this.vaov // 2 * Math.atan(Math.tan(this.viewer.getHfov() / 180 * Math.PI * 0.5) / (canvas.width / canvas.height)) / Math.PI * 180
          this.viewer.setPitchBounds([-vfov / 2, vfov / 2])
          this.viewer.setPitch(0)
        }
      }
    },
    onTouchStart (event) {
      this.showHint = false
      if (this.ready) {
        this.isUserInteracting = true
        const coords = this.viewer.mouseEventToCoords(event)
        this.onMouseDownPitch = coords[0]
        this.onMouseDownYaw = coords[1]
        this.onMouseDownTime = (new Date()).getTime()
      }
    },
    onTouchMove (event) {
      if (this.ready && this.isUserInteracting === true) {
        event.preventDefault()
      }
    },
    onTouchEnd () {
      if (this.ready) {
        this.isUserInteracting = false
      }
      // reactivate orientation if it was active before touching
      this.isOrientationActive && this.viewer.startOrientation()
    },
    onPanoramaClick (event) {
      const time = (new Date()).getTime()
      const coords = this.viewer.mouseEventToCoords(event)
      // console.log('deltaPitch:', Math.abs(coords[0] - this.onMouseDownPitch), 'deltaYaw:', Math.abs(coords[1] - this.onMouseDownYaw))
      if (this.ready && time - this.onMouseDownTime < 800 && Math.abs(coords[0] - this.onMouseDownPitch) + Math.abs(coords[1] - this.onMouseDownYaw) < 0.25) {
        const x = (coords[1] / 360 + 0.5) * this.width // coords[1] =  yaw
        const yPercent = (0.5 - coords[0] / 180) // coords[0] = pitch
        let y = yPercent * this.height
        if (this.type === 'cylinder') {
          const fullY = this.height * 180 / this.vaov
          const yDiff = (fullY - this.height) / 2
          y = (fullY * yPercent) - yDiff
        }
        this.checkForHotspot([x / this.width * 100, y / this.height * 100])
      }
    },
    toggleOrientation () {
      if (!this.isOrientationSupported) return
      this.viewer.isOrientationActive() ? this.viewer.stopOrientation() : this.viewer.startOrientation()
      this.isOrientationActive = this.viewer.isOrientationActive()

      this.setOrientationHistory()
    },
    onHotspotClick (args, s) {
      console.log('---- onHotspotClick', args, s)
    },
    setOrientationHistory () {
      if (!this.isOrientationSupported) return
      window.localStorage.setItem('lastOrientationActive', this.isOrientationActive)
    },
    setOrientationFromHistory (key = undefined) {
      // get last orientation active value from history array and set it
      if (!key) {
        key = 'lastOrientationActive'
      }
      if (this.isOrientationSupported) {
        console.log(window.localStorage)
        const lastOrientationActive = window.localStorage.getItem(key)
        // let lastChildPagesState = this.$xp.history.historyParams[key]
        console.log('set orientationActive from History ' + lastOrientationActive)
        if (lastOrientationActive !== undefined) {
          lastOrientationActive === 'true' ? this.viewer.startOrientation() : this.viewer.stopOrientation()
          this.isOrientationActive = this.viewer.isOrientationActive()
        }
      }
    }
  },
  beforeDestroy () {
    this.screenUnwatcher()
    this.stopAnimate = true
    if (this.ready) {
      this.viewer.destroy()
    }
  }
  // watch: {
  //   '$xp.screen.orientation': {
  //     async handler (v) {
  //       await this.$nextTick()
  //       setTimeout(() => {
  //         this.viewer.destroy()
  //         this.init()
  //       }, 1000)
  //     }
  //   }
  // }
}
</script>
